export const deviceBehaviorFieldKeysMap = new Map([
    ['touch_disabled', 'Touch Disabled'],
    ['relay_polarity_inverted', 'Polarity Inverted'],
    ['led_disabled', 'Led Disabled'],
    ['rf_statistics_enabled', 'RF Stats Enabled'],
    ['usb_host_disabled', 'Usb Host Disabled'],
    ['legacy_offset', 'New Humidity Coefficient'],
    ['modified_rf_cycle_duration', 'Mod. RF cycle dura°'],
]);
